import { combineReducers } from 'redux'
import GenericBenefitsSetReducer from './GenericBenefitsSets'
import AccidentBenefitsSetReducer from './AccidentBenefitsSets'
import MedicalBenefitsSetReducer from './MedicalBenefitsSets'
import DentalBenefitsSetReducer from './DentalBenefitsSets'
import LifeBenefitsSetReducer from './LifeBenefitsSets'
import DisabilityBenefitsSetReducer from './DisabilityBenefitsSets'
import VisionBenefitsSetReducer from './VisionBenefitsSets'
import LevelFundedBenefitsSetReducer from './LevelFundedBenefitsSets'
import LargeGroupCustomBenefitsSetReducer from './LargeGroupCustomBenefitsSets'
import MedicareAdvantageBenefitsSetReducer from './MedicareAdvantageBenefitsSets'
import MedicalBenefitsSetReviewReducer from './MedicalBenefitsSetReviews'
import BenefitsSetFieldHistoryReducer from './BenefitsSetFieldHistories'
import DentalBenefitsSetReviewReducer from './DentalBenefitsSetReviews'
import VisionBenefitsSetReviewReducer from './VisionBenefitsSetReviews'
import BenefitsSetsExportReducer from './BenefitsSetsExports'
import CarrierVerificationReducer from './CarrierVerification'
import LoginReducer from './Login'
import UsersReducer from './Users'
import CarrierBrandsReducer from './CarrierBrands'
import IssuersReducer from './Issuers'
import IssuerDisclaimersReducer from './IssuerDisclaimers'
import IssuerStatusesReducer from './IssuerStatuses'
import IssuerSourcesReducer from './IssuerSources'
import PrivateExchangesReducer from './PrivateExchanges'
import BlobReducer from './Blobs'
import FlashMessagesReducer from './FlashMessages'
import RatesBatchesReducer from './RatesBatches'
import RatesBatchDraftRatesReducer from './RatesBatchDraftRates'
import RatesBatchPublishingsReducer from './RatesBatchPublishings'
import RateFactorSetsReducer from './RateFactorSets'
import CensusesReducer from './Censuses'
import CensusImportsReducer from './CensusImports'
import DocumentsReducer from './Documents'
import RemoveDocuments from './RemoveDocuments'
import EmbargoesReducer from './Embargoes'
import SheetRatesReducer from './SheetRates'
import BulkBenefitsSetsReducer from './BulkBenefitsSets'
import BulkBenefitsSetUpdatesReducer from './BulkBenefitsSetUpdates'
import BulkPlanProductRestoresReducer from './BulkPlanProductRestores'
import BenefitsSetFieldSourceValidationsReducer from './BenefitsSetFieldSourceValidations'
import BenefitsSetExternalIdReducer from './BenefitsSetExternalIds'
import BenefitsSetIdentifiersReducer from './BenefitsSetIdentifiers'
import BenefitsSetsExportPublishingReducer from './BenefitsSetsExportPublishings'
import BenefitsSetsCopyReducer from './BenefitsSetsCopies'
import SharedBusinessRulesReducer from './SharedBusinessRules'
import PlanSharedBusinessRulesReducer from './PlanSharedBusinessRules'
import SheetRatesIdentifiersReducer from './SheetRatesIdentifiers'
import SheetRatesPublishingReducer from './SheetRatesPublishings'
import SheetRatesReviewReducer from './SheetRatesReviews'
import ServiceAreasReducer from './ServiceAreas'
import PlanProductsReducer from './PlanProducts'
import PlanProductHistoriesReducer from './PlanProductHistories'
import IssuerPeriodAudiencesReducer from './IssuerPeriodAudiences'
import IssuerPeriodAudiencePublishingsReducer from './IssuerPeriodAudiencePublishings'
import VericredImportsReducer from './VericredImports'
import HowieGeographiesReducer from './HowieGeographies'
import HowieServiceAreasReducer from './HowieServiceAreas'
import AncillaryServiceAreasReducer from './AncillaryServiceAreas'
import AncillaryRateFactorSetsReducer from './AncillaryRateFactorSets'
import HowieServiceAreasReviewReducer from './HowieServiceAreaReviews'
import FormsReducer from './Forms'
import VericredGroupsReducer from './VericredGroups'
import VericredGroupMemberssReducer from './VericredGroupMembers'
import VericredQuotesReducer from './VericredQuotes'
import VericredQuoteRatesReducer from './VericredQuoteRates'
import VericredQuoteRateMemberRatesReducer from './VericredQuoteRateMemberRates'
import VericredLimitingFactorsReducer from './VericredLimitingFactors'
import SmokeChecksReducer from './SmokeChecks'
import NetworksReducer from './Networks'
import BenefitsSetCsvExportReducer from './BenefitsSetCsvExports'
import PlatformsReducer from './Platforms'
import AdminToolRunsReducer from './AdminToolRuns'
import SBCConfigurationsReducer from './SBCConfigurations'
import BenefitsSetsAvCalculatorEnqueueReducer from './BenefitsSetsAvCalculatorEnqueue'
import GlobalLoadingReducer from './GlobalLoading'

const rootReducer = combineReducers({
  genericBenefitsSets: GenericBenefitsSetReducer,
  accidentBenefitsSets: AccidentBenefitsSetReducer,
  bulkBenefitsSets: BulkBenefitsSetsReducer,
  bulkBenefitsSetUpdates: BulkBenefitsSetUpdatesReducer,
  BulkPlanProductRestores: BulkPlanProductRestoresReducer,
  benefitsSeFieldSourceValidations: BenefitsSetFieldSourceValidationsReducer,
  medicalBenefitsSets: MedicalBenefitsSetReducer,
  dentalBenefitsSets: DentalBenefitsSetReducer,
  lifeBenefitsSets: LifeBenefitsSetReducer,
  disabilityBenefitsSets: DisabilityBenefitsSetReducer,
  visionBenefitsSets: VisionBenefitsSetReducer,
  levelFundedBenefitsSets: LevelFundedBenefitsSetReducer,
  largeGroupCustomBenefitsSets: LargeGroupCustomBenefitsSetReducer,
  dentalBenefitsSetReviews: DentalBenefitsSetReviewReducer,
  visionBenefitsSetReviews: VisionBenefitsSetReviewReducer,
  medicalBenefitsSetReviews: MedicalBenefitsSetReviewReducer,
  benefitsSetsExports: BenefitsSetsExportReducer,
  benefitsSetsExportPublishings: BenefitsSetsExportPublishingReducer,
  BenefitsSetExternalIds: BenefitsSetExternalIdReducer,
  benefitsSetsCopies: BenefitsSetsCopyReducer,
  medicareAdvantageBenefitsSets: MedicareAdvantageBenefitsSetReducer,
  carrierVerification: CarrierVerificationReducer,
  login: LoginReducer,
  users: UsersReducer,
  carrierBrands: CarrierBrandsReducer,
  flashMessages: FlashMessagesReducer,
  issuers: IssuersReducer,
  issuerDisclaimers: IssuerDisclaimersReducer,
  issuerStatuses: IssuerStatusesReducer,
  issuerSources: IssuerSourcesReducer,
  privateExchanges: PrivateExchangesReducer,
  blobs: BlobReducer,
  ratesBatches: RatesBatchesReducer,
  draftRates: RatesBatchDraftRatesReducer,
  ratesBatchPublishings: RatesBatchPublishingsReducer,
  rateFactorSets: RateFactorSetsReducer,
  censuses: CensusesReducer,
  censusImports: CensusImportsReducer,
  documents: DocumentsReducer,
  removeDocuments: RemoveDocuments,
  embargoes: EmbargoesReducer,
  sharedBusinessRules: SharedBusinessRulesReducer,
  planSharedBusinessRules: PlanSharedBusinessRulesReducer,
  sheetRates: SheetRatesReducer,
  benefitsSetIdentifiers: BenefitsSetIdentifiersReducer,
  sheetRatesIdentifiers: SheetRatesIdentifiersReducer,
  sheetRatesPublishings: SheetRatesPublishingReducer,
  sheetRatesReviews: SheetRatesReviewReducer,
  serviceAreas: ServiceAreasReducer,
  planProducts: PlanProductsReducer,
  planProductHistories: PlanProductHistoriesReducer,
  issuerPeriodAudiences: IssuerPeriodAudiencesReducer,
  issuerPeriodAudiencePublishings: IssuerPeriodAudiencePublishingsReducer,
  benefitsSetFieldHistory: BenefitsSetFieldHistoryReducer,
  vericredImports: VericredImportsReducer,
  howieGeographies: HowieGeographiesReducer,
  howieServiceAreas: HowieServiceAreasReducer,
  ancillaryServiceAreas: AncillaryServiceAreasReducer,
  ancillaryRateFactorSets: AncillaryRateFactorSetsReducer,
  howieServiceAreaReviews: HowieServiceAreasReviewReducer,
  forms: FormsReducer,
  groups: VericredGroupsReducer,
  quotes: VericredQuotesReducer,
  quoteRates: VericredQuoteRatesReducer,
  limitingFactors: VericredLimitingFactorsReducer,
  groupMembers: VericredGroupMemberssReducer,
  quoteRateMemberRates: VericredQuoteRateMemberRatesReducer,
  smokeChecks: SmokeChecksReducer,
  networks: NetworksReducer,
  benefitsSetCsvExports: BenefitsSetCsvExportReducer,
  platforms: PlatformsReducer,
  adminToolRuns: AdminToolRunsReducer,
  sbcConfigurations: SBCConfigurationsReducer,
  benefitsSetsAvCalculatorEnqueue: BenefitsSetsAvCalculatorEnqueueReducer,
  globalLoading: GlobalLoadingReducer
})

export default rootReducer
